var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _g, _path37, _path38;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgL2Documents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 160,
    viewBox: "0 0 221 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.805 104.74L163.285 137.45H53.195V104.74L63.555 80.5502H157.445L167.805 104.74Z",
    fill: "#E8B221",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.185 16.1901H64.815C63.241 16.1901 61.965 17.4661 61.965 19.0401V103.14C61.965 104.714 63.241 105.99 64.815 105.99H129.185C130.759 105.99 132.035 104.714 132.035 103.14V19.0401C132.035 17.4661 130.759 16.1901 129.185 16.1901Z",
    fill: "#F8FAFC",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.415 36.38H124.585",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.415 46.26H124.585",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.415 56.15H124.585",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.415 66.03H124.585",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.415 75.92H124.585",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.415 85.8H124.585",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M144.395 26.58H80.025C78.451 26.58 77.175 27.8559 77.175 29.43V113.53C77.175 115.104 78.451 116.38 80.025 116.38H144.395C145.969 116.38 147.245 115.104 147.245 113.53V29.43C147.245 27.8559 145.969 26.58 144.395 26.58Z",
    fill: "#F8FAFC",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M107.185 50.71H87.685C86.1828 50.71 84.965 51.9277 84.965 53.43V67.76C84.965 69.2622 86.1828 70.48 87.685 70.48H107.185C108.687 70.48 109.905 69.2622 109.905 67.76V53.43C109.905 51.9277 108.687 50.71 107.185 50.71Z",
    fill: "#6F9ED4",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M98.585 96.73H87.525C85.7356 96.73 84.285 98.1806 84.285 99.97V100.32C84.285 102.109 85.7356 103.56 87.525 103.56H98.585C100.374 103.56 101.825 102.109 101.825 100.32V99.97C101.825 98.1806 100.374 96.73 98.585 96.73Z",
    fill: "#A6CE3A",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M118.755 50.71H140.135",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M118.755 60.6H140.135",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M118.755 70.48H140.135",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M84.965 80.3699H140.135",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84.965 90.2499H140.135",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M109.915 100.14H140.135",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M159.605 36.9601H95.235C93.6609 36.9601 92.3849 38.2361 92.3849 39.8101V123.91C92.3849 125.484 93.6609 126.76 95.235 126.76H159.605C161.179 126.76 162.455 125.484 162.455 123.91V39.8101C162.455 38.2361 161.179 36.9601 159.605 36.9601Z",
    fill: "#F8FAFC",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M135.825 57.7101H153.115",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M135.825 65.3801H153.115",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M135.825 73.0501H153.115",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M99.915 100.75H117.205",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M99.915 108.42H117.205",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M99.915 117.67H117.205",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M112.165 51.66C104.665 51.76 98.6149 57.86 98.6149 65.38C98.6149 72.9 104.765 79.11 112.345 79.11C116.135 79.11 119.565 77.57 122.055 75.09L112.345 65.38L112.165 51.66Z",
    fill: "#46C4E1",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M112.345 65.38L122.055 75.09C124.535 72.61 126.075 69.17 126.075 65.38H112.345Z",
    fill: "#FBDF47",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M126.075 65.38C126.075 57.8 119.925 51.65 112.345 51.65C112.285 51.65 112.225 51.65 112.165 51.65L112.345 65.37H126.075V65.38Z",
    fill: "#F17171",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M162.455 39.8101C162.455 38.2401 161.175 36.9601 159.605 36.9601H95.235C93.665 36.9601 92.3849 38.2401 92.3849 39.8101V45.3601H162.455V39.8101Z",
    fill: "#7CCBC3",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M134.785 107.82H124.925V117.67H134.785V107.82Z",
    fill: "#BFD865",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M144.635 102.96H134.775V117.67H144.635V102.96Z",
    fill: "#F6903F",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M154.495 93.6601H144.635V117.67H154.495V93.6601Z",
    fill: "#A85BA3",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M130.875 91.5101L140.255 82.5901L145.045 87.3701L152.485 81.0001",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M146.525 81.0001H152.485V86.9701",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M113.995 88.1001H101.955C100.11 88.1001 98.6149 89.5955 98.6149 91.4401V91.5901C98.6149 93.4347 100.11 94.9301 101.955 94.9301H113.995C115.84 94.9301 117.335 93.4347 117.335 91.5901V91.4401C117.335 89.5955 115.84 88.1001 113.995 88.1001Z",
    fill: "#F8BE24",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M141.665 109.39L141.185 116.19C141.135 116.9 140.545 117.46 139.825 117.46H81.165C80.455 117.46 79.855 116.91 79.805 116.19L79.325 109.39C79.175 107.29 77.435 105.66 75.325 105.66H53.195V138.37C53.195 141.38 55.635 143.81 58.635 143.81H162.355C165.365 143.81 167.795 141.37 167.795 138.37V105.66H145.655C143.555 105.66 141.805 107.29 141.655 109.39H141.665Z",
    fill: "#FBE488"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_397",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 105,
    width: 115,
    height: 39
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M141.665 109.39L141.185 116.19C141.135 116.9 140.545 117.46 139.825 117.46H81.165C80.455 117.46 79.855 116.91 79.805 116.19L79.325 109.39C79.175 107.29 77.435 105.66 75.325 105.66H53.195V138.37C53.195 141.38 55.635 143.81 58.635 143.81H162.355C165.365 143.81 167.795 141.37 167.795 138.37V105.66H145.655C143.555 105.66 141.805 107.29 141.655 109.39H141.665Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.355 105.67V133.98C161.355 136.02 159.705 137.68 157.655 137.68H53.195V138.38C53.195 141.39 55.635 143.82 58.635 143.82H162.355C165.365 143.82 167.795 141.38 167.795 138.38V105.67H161.355Z",
    fill: "#FBC719"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M141.665 109.39L141.185 116.19C141.135 116.9 140.545 117.46 139.825 117.46H81.165C80.455 117.46 79.855 116.91 79.805 116.19L79.325 109.39C79.175 107.29 77.435 105.66 75.325 105.66H53.195V138.37C53.195 141.38 55.635 143.81 58.635 143.81H162.355C165.365 143.81 167.795 141.37 167.795 138.37V105.66H145.655C143.555 105.66 141.805 107.29 141.655 109.39H141.665Z",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M140.135 122.98H84.195V133.31H140.135V122.98Z",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgL2Documents);
export default __webpack_public_path__ + "static/media/L2_Documents.8b1e0e74037b0116f04bfdcdcc723712.svg";
export { ForwardRef as ReactComponent };